import React, { useState, useEffect, useRef } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import HeaderEpub from "../../../Components/Header-Epub/Header-Epub";

const CileContentEpubFiles = (props) => {

    const [file, setFile] = useState(null);
    const [loadingSalvar, setLoadingSalvar] = useState(false)
    const [uploadHabilitado, setUploadHabilitado] = useState(false)
    const [tipo, setTipo] = useState('docx')
    const [modalInfosSuccess, setModalInfosSuccess] = useState(false)
    const [successType, setSuccessType] = useState({
        docx: false,
        pdf: false
    })
    const [status, setStatus] = useState({});
    const [loadingStatus, setLoadingStatus] = useState(false);

    const fileInputRef = useRef(null);

    const bookId = props.match.params.idLivro ? props.match.params.idLivro : ''

    const toggleModalInfos = () => setModalInfosSuccess(!modalInfosSuccess);

    const onSelectFile = (e) => {
        setFile(e.target.files[0])
    }

    const salvarArquivo = async () => {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append(`${tipo}File`, file);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/conteudo-cile/epub/upload-arquivos/${bookId}`, bodyFormData)

            .then(response => {
                console.log("Sucesso:", response.data)
                setSuccessType({
                    docx: response.data.successDOCX,
                    pdf: response.data.successPDF
                })
                //response.data.successDOCX e successPDF retornam true para cada arquivo que subiu. Fazer lógica que mostre mensagem de sucesso para o tipo que subiu
                setFile(null)
                if (fileInputRef && fileInputRef.current) fileInputRef.current.value = null;
                setUploadHabilitado(false)
                toggleModalInfos()
                setLoadingSalvar(false)

            }).catch(err => {
                console.log("ERROR:", err)
                setLoadingSalvar(false)
            });
    }

    const chamadaLivro = () => {
        setLoadingStatus(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/epub/detalhes-livro/${bookId}`)
            .then(response => {
                setStatus(response.data.dados.approval_status)
                setLoadingStatus(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
    }

    const handleRadio = (e) => {
        let _value = e.target.value;

        setTipo(_value);
    }

    const handleCancelFile = () => {
        setFile(null);
        if (fileInputRef && fileInputRef.current) fileInputRef.current.value = null;
    }

    useEffect(() => {
        chamadaLivro()
    }, [])

    return (
        <div className="cile-remessas">
            <div className="row">
                {loadingStatus ? (
                    <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status"/>
                    </div>
                ) :
                    <HeaderEpub
                        pageTitle='CILE - Upload de arquivos'
                        nextPage={`geracao/${bookId}`}
                        status={status}
                        etapa={2}
                        bookId={bookId}
                        history={props.history}
                    />
                }
            </div>

            <div className="row no-gutters">
                <div className="col-12 col-lg-12">
                    <div className="card mx-1">
                        <h3 className="m-3">ETAPA 2</h3>
                        <div className="row no-gutters px-3 mb-4 align-items-center">
                            <div className="col-12 col-lg-4 justify-content-center d-flex mb-4 mb-lg-0">

                                {uploadHabilitado ?
                                    <div>
                                        <h5 className="mb-2">Selecione o tipo de arquivo:</h5>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="idTipo"
                                                id="livro"
                                                checked={tipo === 'docx'}
                                                value={'docx'}
                                                onChange={handleRadio}
                                                disabled={file}
                                            />
                                            <label className="form-check-label" htmlFor="docx">Docx {successType.docx && <i className="ml-2 fas fa-check text-success"></i>}</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="idTipo"
                                                id="digital"
                                                checked={tipo === 'pdf'}
                                                value={'pdf'}
                                                onChange={handleRadio}
                                                disabled={file}
                                            />
                                            <label className="form-check-label" htmlFor="pdf">PDF {successType.pdf && <i className="ml-2 fas fa-check text-success"></i>}</label>
                                        </div>
                                    </div>

                                    :
                                    <button className="btn btn-outline-primary" onClick={() => setUploadHabilitado(true)}>Novo arquivo</button>

                                }

                            </div>

                            <div className="col-12 col-lg-8">
                                {uploadHabilitado ?
                                    <div className="row no-gutters align-items-center">
                                        <div className="col-8 col-lg-7">
                                            <label className="pl-2 mr-2"><strong>Arquivo {tipo === 'docx' ? 'Docx' : 'PDF'}:</strong></label>
                                            <input ref={fileInputRef} type="file" accept={`.${tipo}`} className="input-arquivo" onChange={onSelectFile} />
                                        </div>
                                        <div className="col-4 col-lg-5 d-flex align-items-center justify-content-center">
                                            {loadingSalvar ? <div className="spinner-border text-success" role="status" /> :
                                                <button className="btn btn-outline-success" disabled={!file} onClick={() => salvarArquivo()}>Salvar</button>
                                            }
                                            {file && <button className="btn btn-outline-danger ml-4" onClick={handleCancelFile}>Cancelar</button>}
                                        </div>
                                    </div>
                                    : <p className="my-3">Habilite para realizar o upload do arquivo PDF ou docx.</p>
                                }
                            </div>
                        </div>



                    </div>
                </div>
            </div>

            <Modal isOpen={modalInfosSuccess} toggle={toggleModalInfos}>
                <ModalHeader toggle={toggleModalInfos}>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <p>Upload realizado com sucesso!</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { toggleModalInfos() }}>fechar</Button>
                </ModalFooter>
            </Modal>


        </div >
    )
}


export default withRouter(CileContentEpubFiles);